import { Component } from 'react'
import Tab from './Tab'

class Tabs extends Component {
    state = {
        activeIndex: 0,
        key: Math.round(Math.random() * 1000000)
    }

    renderTab = (child, index) => (
        <Tab {...child.props}
            key={`tabs_${this.state.key}--${index}`}
            active={index === this.state.activeIndex}
            onClick={() => this.setState({ activeIndex: index })} />
    )

    render() {
        const { children } = this.props
        const { activeIndex } = this.state

        return (
            <div className="tabs">
                <div className="tabs__header">
                    {children.map(this.renderTab)}
                </div>
                <div className="tabs__body">
                    {children[activeIndex].props.children}
                </div>
            </div>
        )
    }
}

export default Tabs